import '../../../3P/handlebars/handlebars-v3.0.3.js';
import './handlebars.helpers.js';
import './template.js';
